import { createStore } from "redux";
import rootReducer from "./reducers";
import rotateReducer from "./reducers/rotateReducer";
import leftMenuReducer from "./reducers/leftMenuReducer";

const initialState = {
    rotateReducer: { rotating: true },
    leftMenuReducer: { showMenu: true }
};
function configureStore(state = initialState) {
    return createStore(rootReducer, state);
}
export default configureStore;
